var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('oil-form',{attrs:{"title":_vm.formTitle.toUpperCase(),"keys":_vm.keys,"items":_vm.company,"createForm":!_vm.id || !_vm.company.Id,"formCallback":_vm.formCallBack}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }